(() => {
  if (window.guyaEditorialReady) return;
  window.guyaEditorialReady = true;
  const observers = new Map();
  function initialize(scope = document) {
    scope.querySelectorAll('[data-guya-video]').forEach(video => {
      const link = video.querySelector('.guya-video__link');
      if (!link || link.dataset.ready) return;
      link.dataset.ready = 'true';
      const external = video.querySelector('.guya-video__external');
      external?.addEventListener('click', event => event.stopImmediatePropagation(), {capture:true});
      link.addEventListener('click', event => {
        event.stopImmediatePropagation();
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const id = video.dataset.guyaVideo;
        if (!/^[\w-]{11}$/.test(id)) return;
        event.preventDefault();
        const frame = video.querySelector('.guya-video__frame');
        const iframe = document.createElement('iframe');
        const language = (document.documentElement.lang || 'de').split('-')[0];
        const parameters = new URLSearchParams({rel: '0', hl: language});
        // Request the visitor's language only when a caption track is available.
        // These player preferences do not create or translate subtitles.
        if (language === 'en' || language === 'es') {
          parameters.set('cc_lang_pref', language);
          parameters.set('cc_load_policy', '1');
        }
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?' + parameters.toString();
        iframe.title = video.querySelector('h3').textContent;
        iframe.allow = 'encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        frame.replaceChildren(iframe);
        link.replaceWith(frame);
        iframe.focus();
      }, {capture:true});
    });
    scope.querySelectorAll('[data-guya-guide]').forEach(guide => {
      if (observers.has(guide) || !('IntersectionObserver' in window)) return;
      const links = [...guide.querySelectorAll('.guya-guide__nav a')];
      const observer = new IntersectionObserver(entries => {
        const chapters = [...guide.querySelectorAll('.guya-chapter')];
        const current = chapters.find(chapter => {
          const box = chapter.getBoundingClientRect();
          return box.top <= 220 && box.bottom > 220;
        }) || chapters.find(chapter => chapter.getBoundingClientRect().top >= 0);
        if (!current) return;
        links.forEach(link => {
          if (link.hash === '#' + current.id) link.setAttribute('aria-current','location');
          else link.removeAttribute('aria-current');
        });
      }, {rootMargin:'-140px 0px -55% 0px', threshold:0});
      guide.querySelectorAll('.guya-chapter').forEach(chapter => observer.observe(chapter));
      observers.set(guide, observer);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    observers.forEach((observer, guide) => {
      if (event.target.contains(guide)) { observer.disconnect(); observers.delete(guide); }
    });
  });
})();
